import React, { useState, useEffect } from 'react';
import styles from '../static/styles/Highlights.module.css';
import calendarIcon from '../static/img/Home/calendarIcon.svg';
import playIcon from '../static/img/Highlights/iconPlayArrow.svg';
import { fetchGameHighlights } from '../api/highlights';

import fifaIcon from '../static/img/DailyGamingTasks/iconFifaDailyTasks.avif';
import fifaImage from '../static/img/DailyGamingTasks/imageFifaGaming.avif';
import pubgIcon from '../static/img/DailyGamingTasks/iconPubgDailyTasks.png';
import pubgImage from '../static/img/Highlights/pubgHighlight.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import freeFireImage from '../static/img/Highlights/FreeFireHighlight.avif';
import apexImage from '../static/img/DailyGamingTasks/imageApexLegendsGaming.avif';
import codImage from '../static/img/Highlights/codHighlight.avif';
import codIcon from '../static/img/DailyGamingTasks/iconCODDailyTasks.avif';
import minecraftImage from '../static/img/DailyGamingTasks/imageMinecraftGaming.avif';
import clashOfClansImage from '../static/img/DailyGamingTasks/imageCOCGaming.avif';
import clashRoyaleImage from '../static/img/DailyGamingTasks/imageCRGaming.avif';
import fortniteImage from '../static/img/DailyGamingTasks/imageFortniteGaming.avif';
import amongUsImage from '../static/img/DailyGamingTasks/imageAmongUsGaming.avif';
import subwaySurfersImage from '../static/img/DailyGamingTasks/imageSubSurfGaming.avif';
import valorantImage from '../static/img/DailyGamingTasks/imageValorantGaming.avif';
import robloxImage from '../static/img/DailyGamingTasks/imageRobloxGaming.avif';
import { useNavigate } from 'react-router-dom';

const getGameImage = (gameName) => {
    if (!gameName) return pubgImage;
    
    switch (gameName.toLowerCase()) {
        case 'pubg mobile':
        case 'pubg':
            return pubgImage;
        case 'freefire':
        case 'free fire':
            return freeFireImage;
        case 'fifa mobile':
        case 'fifa':
            return fifaImage;
        case 'apex legends':
        case 'apex':
            return apexImage;
        case 'call of duty':
        case 'cod':
            return codImage;
        case 'minecraft':
            return minecraftImage;
        case 'clash of clans':
        case 'coc':
            return clashOfClansImage;
        case 'clash royale':
        case 'cr':
            return clashRoyaleImage;
        case 'fortnite':
            return fortniteImage;
        case 'among us':
        case 'amongus':
            return amongUsImage;
        case 'subway surfers':
        case 'subwaysurfers':
            return subwaySurfersImage;
        case 'valorant':
            return valorantImage;
        case 'roblox':
            return robloxImage;
        default:
            return pubgImage; // Default image
    }
};

// Helper function to get game icon based on game name
const getGameIcon = (gameName) => {
    if (!gameName) return pubgIcon; // Default icon if gameName is undefined
    
    switch (gameName.toLowerCase()) {
        case 'pubg mobile':
        case 'pubg':
            return pubgIcon;
        case 'freefire':
        case 'free fire':
            return freeFireIcon;
        case 'fifa mobile':
        case 'fifa':
            return fifaIcon;
        case 'call of duty':
        case 'cod':
            return codIcon;
        default:
            return pubgIcon; // Default icon
    }
};

const Highlights = () => {
    const [gameHighlightsData, setGameHighlightsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Tournament Highlights | Jazz Esl';
        const loadGameHighlights = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await fetchGameHighlights();
                setGameHighlightsData(data);
            } catch (err) {
                setError(err.message || 'Failed to load game highlights');
            } finally {
                setLoading(false);
            }
        };
        loadGameHighlights();
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Game Highlights</h2>
            <p className={styles.subheading}>Watch highlights from your favorite games</p>
            
            {loading && <div className={styles.loading}>Loading...</div>}
            {error && <div className={styles.error}>Error: {error}</div>}
            
            <div className={styles.cardGrid}>
                {gameHighlightsData.map((highlight) => (
                    <div 
                        key={highlight.id} 
                        className={styles.card}
                        onClick={() => navigate(`/game-highlights?gameId=${highlight.gameId}&gameName=${highlight.game}`, '_blank')}
                        style={{ cursor: 'pointer' }}
                    >
                        <div 
                            className={styles.imageWrapper}
                            style={{ backgroundImage: `url(${getGameImage(highlight.game)})` }}
                        >
                            <div className={styles.playButtonWrapper}>
                                <img src={playIcon} alt="Play" className={styles.playButton} />
                            </div>
                            <div className={styles.gameTagWrapper}>
                                <div className={styles.gameTag}>
                                    <img src={getGameIcon(highlight.game)} alt={highlight.game} className={styles.gameIcon} />
                                </div>
                            </div>
                            <div className={styles.overlay}></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Highlights;
